import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { ItemAreasOptions, ItemEmployeeOptions } from "../../../../types/vacancyInterfeces";
import { createMultiOptions } from '../../../../utils/createOptions';
import { Item } from '../../../../types/interfaces';

const initialState: any = {
  data: {},
  pages: 1,
  page: 1,
  inputValues: {},
  options: {
    daysOptions: [
      { value: 'MONDAY', label: 'Понедельник' },
      { value: 'TUESDAY', label: 'Вторник' },
      { value: 'WEDNESDAY', label: 'Среда' },
      { value: 'THURSDAY', label: 'Четверг' },
      { value: 'FRIDAY', label: 'Пятница' },
      { value: 'SATURDAY', label: 'Суббота' },
      { value: 'SUNDAY', label: 'Воскресенье' }
    ]
  },
  editForm: false,
  resultsupervisors: {},

};
export const singleVacancySlice = createSlice({
  name: 'singleVacancy',
  initialState,
  reducers: {
    reducerGetSingleVacancy: (state: Draft<any>, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.inputValues = {
        schedule: action.payload.schedule.value,
        scheduleExt: action.payload.schedule.ext && Object.keys(action.payload.schedule.ext)[0],
        addressesExt: action.payload.addresses.ext,
        addresses: action.payload.addresses.value,
        areasExt: action.payload.areas.ext,
        areas: action.payload.areas.value,
        citiesExt: action.payload.cities.ext,
        cities: action.payload.cities.value,
        comment: action.payload.comment.value,
        contracts: action.payload.contracts.value,
        contractsExt: action.payload.contracts.ext,
        description: action.payload.description.value,
        formData: action.payload.formData,
        merchsExt: action.payload.merchs.ext,
        merchs: action.payload.merchs.value,
        name: action.payload.name.value,
        pm: action.payload.projects?.value?.map((el: { manager: string, project: { id: number, name: string } }) => { return { id: el.project.id, name: el.manager } }),
        posCountExt: action.payload.posCount.ext,
        posCount: action.payload.posCount.value,
        projects: action.payload.projects.value.map((el: { manager: string, project: { id: number, name: string } }) => el.project),
        regionsExt: action.payload.regions.ext,
        regions: action.payload.regions.value,
        routesExt: action.payload.routes.ext,
        routes: action.payload.routes.value,
        projectRoutes: action.payload.routes.value,
        subway: action.payload.subway.value,
        url: action.payload.url.value,
        workloadExt: action.payload.workload.ext,
        workload: action.payload.workload.value,
        days: action.payload.days.value,
        daysExt: action.payload.days?.ext && action.payload.days?.ext.map((item: { [key: string]: string }) => (Object.keys(item)[0])),
        supervisors: action.payload.supervisors.value,
        supervisorsExt: action.payload.supervisors.ext && action.payload.supervisors.ext.map((el: ItemEmployeeOptions) => {
          return el.employee
        }),
        type: Object.keys(action.payload.type.value)[0],
        status: Object.keys(action.payload.status.value)[0],
        vacancy: action.payload.vacancy.value,
        createdDate: action.payload.createdDate.value,
        virtualSupervisors: action.payload.virtualSupervisors.value,
        modifiedDate: action.payload.modifiedDate,
        virtualSupervisorsExt: action.payload.virtualSupervisors.ext && action.payload.virtualSupervisors.ext[0].employee
          ? action.payload.virtualSupervisors.ext.map((item: ItemEmployeeOptions) => ({ id: item.employee.id }))
          : action.payload.virtualSupervisors.ext,
        salary: action.payload.salary.value && (Number.isInteger(action.payload.salary.value) ? action.payload.salary.value + '.00' : action.payload.salary.value),
        salaryExt: action.payload.salary && (Number.isInteger(action.payload.salary.ext) ? action.payload.salary.ext + '.00' : action.payload.salary.ext),
        revenue: action.payload.revenue && (Number.isInteger(action.payload.revenue.value) ? action.payload.revenue.value + '.00' : action.payload.revenue.value),
        revenueExt: action.payload.revenue && (Number.isInteger(action.payload.revenue.ext) ? action.payload.revenue.ext + '.00' : action.payload.revenue.ext),
        weekTiming: action.payload.weekTiming && action.payload.weekTiming.value,
        weekTimingExt: action.payload.weekTiming && action.payload.weekTiming.ext,
      };
      state.options.regionsOptions = createMultiOptions(action.payload.formData?.regions);
      if (action.payload.areas.ext || action.payload?.areas.ext?.length > 0) {
        const areasOpt = action.payload.formData?.areas
          .filter((option: { id: number, name: string, region: { id: number } }) => action.payload.areas.ext.some((region: { id: number }) => region.id === option.id))
        const regionsList = action.payload.formData?.regions?.filter((option: { id: number, name: string }) =>
          areasOpt.some((region: { id: number }) => region.id === option.id))
        const val = regionsList.map((filteredOption: { id: number, name: string }) => ({
          id: filteredOption.id,
          name: filteredOption.name
        }));
        if (!action.payload.regions.ext || action.payload.regions.ext?.length === 0) {
          state.inputValues = { ...state.inputValues, regionsExt: val };
        } else if (action.payload.regions.ext || action.payload.regions.ext?.length > 0) {
          const uniqueRegions = [...state.inputValues.regionsExt, ...val].reduce((acc, el) => {
            const existingIndex = acc.findIndex((a: { id: number, name: string }) => a.id === el.id);
            if (existingIndex === -1) {
              acc.push(el);
            }
            return acc;
          }, []);
          state.inputValues = { ...state.inputValues, regionsExt: uniqueRegions };
        }
      }

      if (state.inputValues.regionsExt?.length > 0) {
        state.options.areasOptions = action.payload.formData?.areas
          .filter((option: { id: number, name: string, region: { id: number } }) => state.inputValues.regionsExt.some((region: { id: number }) => region.id === option.region.id))
          .map((filteredOption: { id: number, name: string, region: { id: number } }) => ({
            value: filteredOption.id,
            label: filteredOption.name
          }));
      } else {
        state.options.areasOptions = createMultiOptions(action.payload.formData?.areas)
      }
      state.options.contractsOptions = createMultiOptions(action.payload.formData?.contracts);
      state.options.supervisorsOptions = action.payload.formData?.supervisors 
      ?action.payload.formData?.supervisors?.map(
        (option: { employee: { id: number, name: string }, phone?: string }) => ({
          value: option.employee.id,
          label: `${option.employee.name} / ${option.phone || 'Нет номера телефона'}`,
        })
      )
      : [];
      state.options.virtualSupervisorsOptions = action.payload.formData?.virtualSupervisors?.map(
        (option: { employee: { id: number, name: string }, phone?: string }) => ({
          value: option.employee.id,
          label: `${option.employee.name} / ${option.phone || 'Нет номера телефона'}`,
        })
      );
      state.options.projectsOptions = createMultiOptions(action.payload.formData?.projects);
      state.options.managersOptions = action.payload.projects?.value?.map(
        (option: { project: { id: number, name: string }, manager: string }) => ({
          value: option.project.id,
          label: option.manager,
        })
      );
    },
    reducerSingleVacancyIV: (state: Draft<any>, action: PayloadAction<any>) => {
      state.inputValues = { ...action.payload };
    },
    reducerSingleVacancyStatus: (state: Draft<any>, action: PayloadAction<any>) => {
      state.clientsStatus = action.payload;
    },
    reducerSingleVacancyStatusMessage: (state: Draft<any>, action: PayloadAction<any>) => {
      state.clientsStatusMessage = action.payload;
    },
    reducerSingleVacancyStatusMultiSelect: (state: Draft<any>, action: PayloadAction<any>) => {
      state.editForm = true;
      state.inputValues = { ...state.inputValues, ...action.payload }
      if (action.payload.regionsExt?.length > 0 && (!action.payload.areasExt || action.payload.areasExt.length === 0)) {
        const areasList = action.payload.formData?.areas
          .filter((option: ItemAreasOptions) => action.payload.regionsExt.some((region: Item) => region.id === option.region.id));
        state.options.areasOptions = areasList.map((filteredOption: ItemAreasOptions) => ({
          value: filteredOption.id,
          label: filteredOption.name
        }));;
      } else if (action.payload.regionsExt?.length === 0) {
        state.options.areasOptions = createMultiOptions(action.payload.formData?.areas);
      }
      if ((action.payload.areasExt && action.payload?.areasExt?.length > 0) && (!action.payload.regionsExt || action.payload.regionsExt?.length === 0)) {
        const areasOpt = action.payload.formData?.areas
          .filter((option: ItemAreasOptions) => action.payload.areasExt.some((region: Item) => region.id === option.id));
        const regionsList = action.payload.formData?.regions?.filter((option: Item) =>
          areasOpt.some((region: ItemAreasOptions) => region.region.id === option.id));
        const regId = areasOpt.map((el: ItemAreasOptions) => { return el.region.id })
        state.options.areasOptions = action.payload.formData?.areas?.map(
          (option: ItemAreasOptions) => {
            if (regId.includes(option.region.id)) {
              return {
                value: option.id,
                label: option.name,
              };
            } else {
              return null;
            }
          }).filter(Boolean);
        const val = regionsList.map((filteredOption: Item) => ({
          id: filteredOption.id,
          name: filteredOption.name
        }));
        state.inputValues = { ...state.inputValues, regionsExt: val };
      }
    },
    reducerSingleVacancySalary: (state: Draft<any>, action: PayloadAction<any>) => {
      const { salaryExt, revenueExt } = action.payload;
      state.inputValues = {
        ...state.inputValues,
        salaryExt: typeof salaryExt !== 'undefined' ? (salaryExt !== '.00' ? salaryExt : '') : state.inputValues.salaryExt,
        revenueExt: typeof revenueExt !== 'undefined' ? (revenueExt !== '.00' ? revenueExt : state.inputValues.revenueExt) : state.inputValues.revenueExt,
      };
    },
    reducerSingleVacancyWeekTiming: (state: Draft<any>, action: PayloadAction<any>) => {
      const { weekTimingExt } = action.payload;
      state.inputValues = {
        ...state.inputValues,
        weekTimingExt: weekTimingExt || state.inputValues.weekTimingExt,
      };
    },
    reducerSort: (state: Draft<any>, action: PayloadAction<any>) => {
      state.editForm = action.payload;
    },
    reducerClearInputValuesSingleVacancy: () => {
			return initialState;
		},
  },
});

export const {
  reducerGetSingleVacancy,
  reducerSingleVacancyIV,
  reducerSingleVacancyStatus,
  reducerSingleVacancyStatusMessage,
  reducerClearInputValuesSingleVacancy,
  reducerSingleVacancyStatusMultiSelect,
  reducerSingleVacancySalary,
  reducerSingleVacancyWeekTiming,
  reducerSort,
} = singleVacancySlice.actions;

export default singleVacancySlice.reducer;
